import React from 'react'
import { useTranslation } from 'react-i18next';
import LeftLeaf from '../assets/leaf-left.svg'
import RightLeaf from '../assets/leaf-right.svg'
import BeforeAfter from "../assets/before&after.png"
import BeforeAfter2 from "../assets/before-after.png"
import { FaDumbbell, FaHeartbeat, FaFire, FaSmile } from 'react-icons/fa'

const WhatBenefits = () => {
    const { t } = useTranslation();
    const transformations = [
      {
          src: BeforeAfter,
          alt: "Before and after treatment",
          title: `${t('before')} ${t('after')}`,
          desc: t('beforeAfter')
      },
      // {
      //     src: Result,
      //     alt: "Result after treatment",
      //     title: t('theResult'),
      //     desc: t('result')
      // },
      {
          src: BeforeAfter2,
          alt: "Another transformation",
          title: t('transformation'),
          desc: t('Transformation')
      },
  ];

    
    const benefits = [
        { icon: <FaDumbbell />, title: t('fitnessRecovery'), desc: t('fitnessRecoveryDesc')},
        { icon: <FaHeartbeat />, title: t('painReduction'), desc: t('painReductionDesc') },
        { icon: <FaFire />, title: t('fatLoss'), desc: t('fatLossDesc')},
        { icon: <FaSmile />, title: t('antiAging'), desc: t('antiAgingDesc') },
      ];

  return (
  <div className='relative'>
      <img src={LeftLeaf} alt="leaf image" className='absolute top-0 left-0 -z-10' />
    <div className="mt-20 p-6 container mx-auto ">
      <div className='flex justify-between flex-col  mx-auto gap-4 text-center'>
       <h2 className="md:text-4xl text-3xl font-bold text-center font-Merriweather">{t('whatBenefitsTitle')}</h2>
       <p className='mb-10 text-gray-600 font-medium'>{t('whatBenefitsInfo')}</p>
      </div>

    <div className='flex flex-wrap justify-between gap-y-10 md:mt-10 gap-5'>
       {benefits.map((benefit, index) => (
            <div key={index} data-aos='flip-left' className="flex flex-col bg-gray-50 py-7 px-5 w-full md:w-1/5 rounded-lg ">
              <div className="text-3xl mb-4 bg-gray-200 text-[rgb(161,121,61)] max-w-max rounded-full p-4 ">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-semibold">{benefit.title}</h3>
              <p className='pt-4 text-sm text-gray-600 leading-snug'>{benefit.desc}</p>
            </div>
          ))}
    </div>

    {/* Before and after transformation section*/}
    <div className="flex flex-wrap justify-between mt-20 items-center gap-8">
            {transformations.map((transformation, index) => (
                <div key={index} className="relative h-[350px] rounded-lg w-full md:w-[46%] pt-0 p-7 bg-gray-50">
                    <div className='py-7'>
                    <h3 className="text-2xl mb-1 font-Merriweather text-extrabold">{transformation.title}</h3>
                    <p>{transformation.desc}</p>
                    </div>
                    <img src={transformation.src} alt={transformation.alt} className="w-full object-cover h-3/5 rounded-lg shadow-md" />
                </div>
            ))}
        </div>
    </div>
    <img src={RightLeaf} alt="leaf image" className='absolute top-0 right-0 -z-10' />
  </div>
  )
}

export default WhatBenefits
